
import React, { useEffect } from 'react';
import HeroSection from '@/components/HeroSection';
import LocationSection from '@/components/LocationSection';
import FlavorGallery from '@/components/FlavorGallery';
import ParticleBackground from '@/components/ParticleBackground';

const Index = () => {
  // Add effect to hide the Lovable badge
  useEffect(() => {
    // Find and hide the Lovable badge that appears at the bottom of the page
    const hideLovableBadge = () => {
      const badges = document.querySelectorAll('[class*="lovable-badge"]');
      badges.forEach(badge => {
        if (badge instanceof HTMLElement) {
          badge.style.display = 'none';
        }
      });
    };
    
    // Run initially and also set up a mutation observer to catch any dynamically added badges
    hideLovableBadge();
    
    const observer = new MutationObserver(mutations => {
      hideLovableBadge();
    });
    
    observer.observe(document.body, { 
      childList: true, 
      subtree: true 
    });
    
    return () => observer.disconnect();
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <ParticleBackground />
      <HeroSection />
      <FlavorGallery />
      <LocationSection />
      
      <footer className="bg-floresta-acai text-white py-8 px-4">
        <div className="container mx-auto text-center">
          <h2 className="text-3xl font-bold mb-4">Floresta Sorvetes & Açaí</h2>
          <p className="mb-6">Uma experiência gelada que encanta</p>
          
          <hr className="my-6 border-white/30 max-w-xs mx-auto" />
          
          <p className="text-sm opacity-80">
            Inauguração 17 de maio às 13h | Av. do Taboão, 4052 - São Bernardo do Campo
          </p>
        </div>
      </footer>
    </div>
  );
};

export default Index;
